import { useEffect, useState } from 'react'
import { useAuth } from 'context/user'
import { graphqlRequest } from 'lib/helpers'
import { Connection } from 'types/api'
import listMyConnectionsQuery from 'graphql/listMyConnections.graphql'

export const useYouTubeConnection = (refreshKey = 0): {
  youtubeConnected: boolean
  youtubeChannelName: string | null
  youtubeLinked: boolean | null
} => {
  const { auth0Token } = useAuth()
  const [youtubeConnected, setYoutubeConnected] = useState(false)
  const [youtubeChannelName, setYoutubeChannelName] = useState<string | null>(null)
  const [youtubeLinked, setYoutubeLinked] = useState<boolean | null>(null)

  useEffect(() => {
    if (auth0Token === undefined) return
    let cancelled = false
    const load = async (): Promise<void> => {
      try {
        const resp = await graphqlRequest<{ connections: Connection[] }>(
          listMyConnectionsQuery, {}, auth0Token
        )
        if (cancelled) return
        const youtube = (resp.connections ?? []).find((c) => c.provider === 'youtube')
        const connected = youtube !== undefined && youtube.status === 'connected'
        setYoutubeConnected(connected)
        setYoutubeChannelName(
          connected ? (youtube.displayName ?? youtube.login ?? null) : null
        )
        setYoutubeLinked(youtube != null)
      } catch {
      }
    }
    void load()
    return () => { cancelled = true }
  }, [auth0Token, refreshKey])

  return { youtubeConnected, youtubeChannelName, youtubeLinked }
}
